module.exports = __webpack_public_path__ + "static/img/up-corner-8m-x-1m-inverted_256.992e13d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/up-corner-8m-x-1m-inverted_256.png
// module id = 3n+C
// module chunks = 0